const loadedScripts = {};

export function loadScript(scriptPath, id = "") {
    if (loadedScripts[scriptPath]) {
        return Promise.resolve(scriptPath);
    }

    return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = scriptPath;
        script.type = "text/javascript";

        if (id) {
            script.id = id;
        }

        loadedScripts[scriptPath] = true;

        script.onload = () => {
            resolve(scriptPath);
        };

        script.onerror = () => {
            reject(scriptPath);
            window.location = "/";
        };

        document.body.appendChild(script);
    });
}